export default function Image({ icon }) {
  return icon && <img src={icon} className={'achievement__image'} />;
}
